import config from '../config/config.json';

export default {
    create(file) {
        const data = new FormData();
        const token = localStorage.getItem('token');

        data.append("file", file, file.name);
        return fetch(
            `${config.api}/pictures`,
            {
                method: 'POST',
                body: data,
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }
        ).then(response => response.json());
    },

    async allow(extension) {
        const token = localStorage.getItem('token');

        const response = await fetch(`${config.api}/pictures/allow/${extension}`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });

        if (!response.ok) {
            throw new Error('Unable to prepare the image upload. Please try again.');
        }

        return response.json();
    },

    async remoteUpload(url, file, headers = {}) {
        const response = await fetch(url, {
            method: 'PUT',
            body: file,
            headers: {
                'Content-Type': file.type,
                ...headers
            }
        });

        if (!response.ok) {
            throw new Error(response.status === 412
                ? 'This image already exists. Please try uploading it again.'
                : 'Unable to upload the image. Please try again.');
        }
    },

    async createAfterRemoteUpload(fileName) {
        const token = localStorage.getItem('token');
        const response = await fetch(
            `${config.api}/pictures/after-remote-upload`,
            {
                method: 'POST',
                body: JSON.stringify({
                    path: fileName
                }),
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            }
        );

        if (!response.ok) {
            throw new Error('Unable to save the uploaded image. Please try again.');
        }

        return response.json();
    }
};
